import { combineReducers } from 'redux';
import usuarioReducer from './usuarioReducer';

const rootReducer = combineReducers({ usuarioReducer });

export default rootReducer;